export default {
  computed: {
    triggered() {
      return [];
    },
    triggeredBy() {
      return [];
    },
  },
};
